// Vendor
import $ from 'jquery';
import Helpers from 'helpers/util';

// Elements
let $loginRegisterBlock = $('.login-register-block');
let $updateAction = $('.js-update-home-action');

// Vars
let actionUrl = null;
let loginRegisterOffset;

const fixLoginRegister = () => {
	let scrollTop = $(window).scrollTop();
	let contentWrapperOffset = $('.home-content-wrapper').height() - $loginRegisterBlock.height() + 100;

	if ( scrollTop <= loginRegisterOffset ) {
		// default, not fixed or absolute
		$loginRegisterBlock
			.removeClass('fixed bottom')
			.css({
				width: 'auto'
			});
	} else if ( scrollTop > loginRegisterOffset && scrollTop <= contentWrapperOffset ) {
		// fixed at top
		$loginRegisterBlock
			.removeClass('bottom')
			.addClass('fixed')
			.css({
				width: $loginRegisterBlock.parent().width()
			});
	} else {
		// absolute at bottom
		$loginRegisterBlock
			.removeClass('fixed')
			.addClass('bottom')
			.css({
				width: $loginRegisterBlock.parent().width()
			});
	}
};

const toggleFooterButtons = () => {
	let scrollTop = $(window).scrollTop();
	let loginRegisterOffset = $loginRegisterBlock.offset().top + $loginRegisterBlock.height();
	let footerTopOffset = $('footer').offset().top - $(window).height();

	if ( scrollTop > loginRegisterOffset && scrollTop < footerTopOffset ) {
		// below the register/login forms and above the footer
		$('.login-register-quick-links').addClass('active');
	} else {
		$('.login-register-quick-links').removeClass('active');
	}
};

const updateFormAction = () => {
	if (actionUrl) {
		$('.form-registration').find('form').attr('action', actionUrl);
		$('.form-login').find('form').attr('action', actionUrl);
	} else {
		$('.form-registration').find('form').attr('action', '/');
		$('.form-login').find('form').attr('action', '/');
	}
};

// On Footer links, scroll to form
const scrollToForm = (text) => {
	let loginRegisterTop = $loginRegisterBlock.offset().top - 20;
	let $el = $('#login-tab-btn');

	if (text === 'Register') {
		$el = $('#register-tab-btn');
	}

	$('body,html').animate({scrollTop: loginRegisterTop}, function(){
		$el.click();
	});
};

const _attachHandlers = () => {
	loginRegisterOffset = $loginRegisterBlock.offset().top;

	Helpers.pubsub.subscribe('onLightboxShow', (n, e) => {
		if (e.hasClass('card-link')) {
			actionUrl = e.attr('href');
		} else {
			actionUrl = null;
		}
	});

	// Fix login/register box on desktop
	$(document).ready(fixLoginRegister);
	$(window).on('scroll resize', fixLoginRegister);

	// Home page login/register mobile quick links
	$(document).ready(toggleFooterButtons);
	$(window).scroll(toggleFooterButtons);

	$updateAction.on('click', (evt) => {
		let currentTarget = $(evt.currentTarget);
		let text = $.trim(currentTarget.text());

		// If footer or mobile quick links, reset destination URL
		if (currentTarget.closest('footer').length || currentTarget.closest('.login-register-quick-links').length) {
			actionUrl = null;
			scrollToForm(text);
		// If popup register / login:
		} else {
			if (text === 'Register') {
				$('#register-tab-btn').click();
			} else {
				$('#login-tab-btn').click();
			}
			if (window.innerWidth < 768) {
				scrollToForm(text);
			}
		}

		// Update 'action' as per SPVP-174
		updateFormAction();

	});

	// anchor/tab go to functions (DEPRECATED)
	window.goToRegisterForm = () => {
		// let loginRegisterTop = $loginRegisterBlock.offset().top - 20;
		// $('body,html').animate({scrollTop: loginRegisterTop}, function(){
		// 	$('#register-tab-btn').click();
		// });
	};

	window.goToLoginForm = () => {
		//let loginRegisterTop = $loginRegisterBlock.offset().top - 20;
		//console.log(loginRegisterTop);
		// $('body,html').animate({scrollTop: loginRegisterTop}, function(){
		// 	$('#login-tab-btn').click();
		// });
		//updateFormAction();
		//$('#login-tab-btn').click();
	};

};

const _init = () => {
	if ($loginRegisterBlock.length > 0) {
		_attachHandlers();
	}
};

_init();
